import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { OrdinamentoVO } from "@app/shared/vo/ordinamentoVO";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";
import { FascicoloVO } from "@app/shared/vo/fascicoloVO";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { UnitaDocumentariaVO } from "@app/shared/vo/unita-documentariaVO";
import { DocumentoVO } from "@app/shared/vo/documentoVO";
import { ModalePreviewComponent } from "@app/utility/components/modale-preview-pdf/modale-preview-pdf.component";
import { ProtocolloService } from "@app/shared/services/protocollo.service";

@Component({
  selector: "app-risultati-ricerca-documenti",
  templateUrl: "./risultati-ricerca-documenti.component.html",
})
export class RisultatiRicercaDocumentiComponent implements OnInit, OnChanges {
  @ViewChild(DatatableComponent, { static: false })
  ngxDatatable: DatatableComponent;

  @ViewChild("appModalePreview", { static: false })
  previewModal: ModalePreviewComponent;

  ordinamento: OrdinamentoVO;

  @Input() paginazione: PaginazioneVO;

  @Input() rows: FascicoloVO[] | UnitaDocumentariaVO[] | DocumentoVO[];

  @Input() loadingIndicator: boolean;

  @Input() messages: any;

  @Output() sortColumn: EventEmitter<any> = new EventEmitter<any>();

  @Output() setPage: EventEmitter<any> = new EventEmitter<any>();

  @Output() emettiChiusuraModale: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();

  @Output() emettiDocumento: EventEmitter<DocumentoVO> = new EventEmitter<
    DocumentoVO
  >();

  ColumnMode = ColumnMode;
  idDocumentoPreview: string;
  showPreviewDoc: boolean = false;

  constructor(private protocolloService: ProtocolloService) {}

  ngOnInit() {}
  ngAfterViewInit() {
    //this.ngxDatatable.columnMode = ColumnMode.force;
  }

  ngOnChanges(changes: SimpleChanges): void {}
  onSort(event: any) {
    console.log("sort", event);
    this.sortColumn.emit(event);
  }

  public onSetPage(pageInfo) {
    console.log("***onsetPage -- START", pageInfo);
    this.setPage.emit(pageInfo.offset);
    console.log("setPage -- END ", this.paginazione);
  }

  showPreviewModal(idDocumento: string) {
    console.log("Apro modale? ", idDocumento);
    this.previewModal.openModal();
    this.idDocumentoPreview = idDocumento;
    this.showPreviewDoc = true;
  }

  public download(index: string, nome: string) {
    console.log("download file ", index);
    let docToDownload: DocumentoVO = null;
    this.rows.forEach((documento) => {
      if (documento.idRepository === index) {
        docToDownload = documento;
      }
    });

    if (docToDownload === null) {
      docToDownload = new DocumentoVO();
      docToDownload.idRepository = index;
      docToDownload.nome = nome;
    }
    this.protocolloService.downloadFileProgress(docToDownload);
  }
  public selectDoc(row: DocumentoVO) {
    console.log("[risultatiRicercaComponent][selectDoc] row", row);
    this.emettiDocumento.emit(row);
  }
  toggleExpandRow(row) {
    console.log("Toggled Expand Row!", row);
    this.ngxDatatable.rowDetail.toggleExpandRow(row);
  }
  getHeight(row: any): number {
    if (row) {
      return row.someHeight;
    }
  }
}
